<template>
  <div class="observatory-usage-guide">
    <div v-for="(usageItem, index) in enables" :key="index" class="legend-area">
      <div class="legend-title" v-if="usageItem.title">
        {{ usageItem.title }}
      </div>
      <v-card class="legend" tile elevation="5">
        <div
          v-for="(o, index) in usageItem.colors"
          :key="index"
          class="val"
          :style="{ backgroundColor: o.color }"
        >
          {{ o.value }}
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { OBSERVATORY, STAGES } from "../../../enums/Type";
export default {
  name: "MobileObservatoryUsageGuide",
  computed: {
    riskSubControl() {
      return this.$store.getters.riskSubControl;
    }
  },
  watch: {
    riskSubControl() {
      const enables = [];
      this.riskSubControl.observatory.forEach(type => {
        const guide = this.usageGuide.find(guide => {
          return guide.type === type;
        });
        if (guide) {
          enables.push(guide);
        }
      });
      this.enables = enables;
    }
  },
  mounted() {
    const enables = [];
    this.riskSubControl.observatory.forEach(type => {
      const guide = this.usageGuide.find(guide => {
        return guide.type === type;
      });
      if (guide) {
        enables.push(guide);
      }
    });
    this.enables = enables;
  },
  data() {
    return {
      enables: [],
      usageGuide: [
        {
          title: "水位",
          type: OBSERVATORY.STAGE.code,
          colors: [
            { color: STAGES.OUTBREAK.color, value: STAGES.OUTBREAK.label },
            { color: STAGES.DANGEROUS.color, value: STAGES.DANGEROUS.label },
            { color: STAGES.EVACUATION.color, value: STAGES.EVACUATION.label },
            { color: STAGES.WARNING.color, value: STAGES.WARNING.label },
            { color: STAGES.STANDBY.color, value: STAGES.STANDBY.label },
            { color: STAGES.START.color, value: STAGES.START.label },
            { color: STAGES.NORMAL.color, value: STAGES.NORMAL.label },
            { color: STAGES.DEFICIT.color, value: STAGES.DEFICIT.label }
          ]
        },
        {
          title: "雨量(mm/10分)",
          type: OBSERVATORY.RAIN.code,
          colors: [
            { color: "#800080", value: "20㎜以上" },
            { color: "#ff0000", value: "10㎜以上" },
            { color: "#d88100", value: "5㎜以上" },
            { color: "#1e42af", value: "1㎜以上" },
            { color: "#ffffff", value: "1㎜未満" },
            { color: "#aaaaaa", value: "休止・欠測等" }
          ]
        },
        {
          title: "風速（m/s）",
          type: OBSERVATORY.WIND.code,
          colors: [
            { color: "#b40068", value: "25m/s以上" },
            { color: "#f12705", value: "20m/s以上" },
            { color: "#f49904", value: "15m/s以上" },
            { color: "#f9f503", value: "10m/s以上" },
            { color: "#3e42ff", value: "5m/s以上" },
            { color: "#b9ebfa", value: "5m/s未満" }
          ]
        },
        {
          title: "積雪深（cm）",
          type: OBSERVATORY.SNOW.code,
          colors: [
            { color: "#ba206e", value: "200cm以上" },
            { color: "#ff3700", value: "150cm以上" },
            { color: "#ffa021", value: "100cm以上" },
            { color: "#fbf43c", value: "50cm以上" },
            { color: "#0041FF", value: "20cm以上" },
            { color: "#218CFF", value: "5cm以上" },
            { color: "#A0D2FF", value: "1cm以上" },
            { color: "#FFFFFF", value: "1cm未満" }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.observatory-usage-guide {
  overflow: hidden;
  padding-bottom: 10px;
  width: 100%;
  text-align: right;
}
.legend-area {
  vertical-align: top;
  .legend-title {
    text-align: right;
    font-size: 12px;
    font-weight: bold;
    white-space: pre-wrap;
    text-shadow: 1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff,
      -1px -1px 0 #ffffff;
  }
  .legend {
    margin-bottom: 10px;
    .val {
      color: #ffffff;
      text-shadow: 1px 1px 0 #2c2c2c, -1px 1px 0 #2c2c2c, 1px -1px 0 #2c2c2c,
        -1px -1px 0 #2c2c2c;
      font-weight: bold;
      font-size: 12px;
      min-width: 12px;
      text-align: center;
      line-height: 1;
      padding: 0 10px;
      line-height: 20px;
      height: 20px;
      opacity: 0.9;
    }
  }
}
</style>
